import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';

var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);

  var _super = _createSuper(Select);

  function Select(props) {
    var _this;

    _classCallCheck(this, Select);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "Options", function () {
      if (_this.props.dataType === 'assignmentTypes') {
        return _this.props.options.map(function (item, i) {
          return /*#__PURE__*/React.createElement("option", {
            key: item.id,
            value: item.id
          }, item.value);
        });
      } else if (_this.props.dataType == 'assignment') {
        return _this.props.status.assignmentStatus.map(function (item, i) {
          if (item.selectable) {
            return /*#__PURE__*/React.createElement("option", {
              key: item.id,
              value: item.id
            }, item.value);
          }
        });
      } else if (_this.props.dataType == 'assignmentStatus') {
        return _this.props.options.map(function (item, i) {
          if (item.selectable) {
            return /*#__PURE__*/React.createElement("option", {
              key: item.id,
              value: item.id
            }, item.value);
          }
        });
      } else if (_this.props.dataType == 'plan') {
        return _this.props.options.map(function (item, i) {
          return /*#__PURE__*/React.createElement("option", {
            key: item.id,
            value: item.id
          }, item.value);
        });
      } else if (_this.props.dataType == 'assignment-plan') {
        return _this.props.options.map(function (item, i) {
          return /*#__PURE__*/React.createElement("option", {
            key: item.id,
            value: item.id
          }, item.title);
        });
      } else if (_this.props.dataType == 'groups-selector') {
        return _this.props.options.map(function (item, i) {
          return /*#__PURE__*/React.createElement("option", {
            key: item.id,
            value: item.id
          }, item.title);
        });
      }

      return _this.props.options.map(function (item, i) {
        return /*#__PURE__*/React.createElement("option", {
          key: item.value,
          value: item.value
        }, item.text);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "placeholderOption", function () {
      if (_this.props.placeholder) {
        var selectValue = '0';

        if (_this.props.placeholderValue) {
          selectValue = _this.props.placeholderValue;
        } else if (_this.props.placeholderValue === '') {
          selectValue = _this.props.placeholderValue;
        }

        if (_this.props.placeholder != null && _this.props.placeholder != '' && !_this.props.placeholder) {
          return /*#__PURE__*/React.createElement("option", {
            value: selectValue
          }, _this.props.placeholder);
        }

        return /*#__PURE__*/React.createElement("option", {
          value: selectValue
        }, _this.props.translate('select-an-alternative'));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      if (_this.props.onChange != null && typeof _this.props.onChange == 'function') {
        _this.props.onChange(event);
      }

      if (_this.props.input != null) {
        if (_this.props.input.onChange != null && typeof _this.props.input.onChange == 'function') {
          _this.props.input.onChange(event.target.value);
        }
      }
    });

    return _this;
  }

  _createClass(Select, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          name = _this$props.name,
          id = _this$props.id,
          input = _this$props.input,
          selectedValue = _this$props.selectedValue,
          disabled = _this$props.disabled,
          meta = _this$props.meta;
      return /*#__PURE__*/React.createElement("div", {
        className: "select"
      }, label ? /*#__PURE__*/React.createElement("label", {
        htmlFor: name
      }, label) : '', /*#__PURE__*/React.createElement("select", _extends({
        name: name,
        id: id ? id : name,
        disabled: disabled,
        defaultValue: selectedValue
      }, input, {
        onChange: this.onChange
      }), this.placeholderOption(), this.Options()), typeof meta !== 'undefined' ? /*#__PURE__*/React.createElement("div", null, meta.touched && (meta.error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem'
        }
      }, meta.error) || meta.warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem'
        }
      }, meta.warning))) : null);
    }
  }]);

  return Select;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    status: state.status.status
  };
}

export default connect(mapStateToProps)(Select);